import { Button } from '@/components/button'
import { DropdownProfile } from '@/components/dropdown/Profile'
import { IFrameMobileModal, IFrameModal } from '@/components/modal'
import { ROUTE_DASHBOARD, ROUTE_LOGIN, ROUTE_PLAYERS } from '@/constants/Routes'
import { useOutsideClick } from '@/hooks/useOutsideClick'
import { useAppSelector } from '@/hooks/useRedux'
import { userSelector } from '@/pages/user/selectors'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useMediaQuery } from 'usehooks-ts'
import { authSelector } from '../auth/selectors'
import {
  DrawerMenu,
  DuprAthletes,
  ExploreTechnology,
  Footer,
  Header,
  MobileHeader,
  OurPhilosophy,
  SectionCus,
  Sponsors,
  TabletHeader,
  Testimonials,
  WhatWeDo,
} from './components'

export const Landing = () => {
  const { t } = useTranslation()

  const navigate = useNavigate()
  const location = useLocation()

  const { token } = useAppSelector(authSelector)
  const { user } = useAppSelector(userSelector)
  const isMobile = useMediaQuery('(max-width: 767px)')

  const queryParams = new URLSearchParams(location.search)
  const rValue = queryParams.get('r')

  const [showDropdownProfileMenu, setShowDropdownProfileMenu] = useState(false)
  const [openIframe, setOpenIframe] = useState(false)

  const onToggleIframe = () => setOpenIframe(!openIframe)

  const handleClickOutside = () => {
    if (!isMobile) setShowDropdownProfileMenu(false)
  }

  const ref = useOutsideClick(handleClickOutside)

  const [drawerOpen, setDrawerOpen] = useState(false)

  const handleDrawerOpen = () => setDrawerOpen(!drawerOpen)

  const toggleShowDropdownProfileMenu = () => {
    setShowDropdownProfileMenu(!showDropdownProfileMenu)
  }

  useEffect(() => {
    if (token && rValue !== '0') {
      navigate(ROUTE_DASHBOARD)
    }

    if (!token) {
      navigate(ROUTE_LOGIN)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token])

  useEffect(() => {
    if (showDropdownProfileMenu || openIframe || drawerOpen) {
      document.body.style.overflowY = 'hidden'
    }
    if (!showDropdownProfileMenu && !openIframe && !drawerOpen) {
      document.body.style.overflowY = 'auto'
    }
  }, [showDropdownProfileMenu, openIframe, drawerOpen])

  return (
    <>
      <DrawerMenu drawerOpen={drawerOpen} onDrawerToggle={handleDrawerOpen} />
      <div className="bg-white">
        {/* Banner */}
        <div className="bg-[url('/img/background.png')] min-h-screen bg-top bg-no-repeat bg-cover">
          <TabletHeader toggleShowDropdown={toggleShowDropdownProfileMenu} />
          <Sponsors />
          <MobileHeader onDrawerToggle={handleDrawerOpen} toggleShowProfileMenu={toggleShowDropdownProfileMenu} />
          <SectionCus>
            <Header toggleShowDropdown={toggleShowDropdownProfileMenu} onToggleIframe={onToggleIframe} />
            <div className="px-10 py-20 flex flex-col lg:flex-row lg:justify-between">
              <div className="text-white max-w-2xl flex flex-col justify-center gap-y-8">
                <p className="text-5xl leading-tight font-bold">{t('home.pickleballGlobal')}</p>
                <p className="text-2xl font-semibold">{t('home.freePlayers')}</p>
                <p className="text-lg font-semibold">{t('home.trustedByTheWorld')}</p>
                <Link to={ROUTE_PLAYERS}>
                  <Button className="hover:opacity-50">
                    <img src="img/search-bar.png" className="h-20" />
                  </Button>
                </Link>
                <div className="flex">
                  <button
                    className="p-3 hover:bg-darkNavy hover:bg-opacity-10 hover:rounded"
                    onClick={() => {
                      window.open('https://apps.apple.com/us/app/dupr/id1567932355')
                    }}
                  >
                    <img src="img/app_store_logo.svg" className="w-44" />
                  </button>
                  <button
                    className="p-3 hover:bg-darkNavy hover:bg-opacity-10 hover:rounded"
                    onClick={() => {
                      window.open('https://play.google.com/store/apps/details?id=gg.dupr&hl=en&gl=US&pli=1')
                    }}
                  >
                    <img src="img/google_play_logo.png" className="w-44" />
                  </button>
                </div>
              </div>
              <div className="flex justify-center ">
                <img className="w-[384px] object-contain" src="img/iphone-mockup.png" alt="iphone-mockup" />
              </div>
            </div>
            {/* Dropdown Profile menu for desktop */}
            {user && (
              <div ref={ref}>
                <DropdownProfile
                  isDropdown
                  openDropdown={showDropdownProfileMenu}
                  user={user}
                  dropdownClass="absolute top-[-4rem] right-2 border-t-[1px] lg:top-24 lg:right-5 lg:border-t-[0px]"
                  onRunEvent={() => {
                    setShowDropdownProfileMenu(false)
                    onToggleIframe()
                  }}
                  onCloseModal={toggleShowDropdownProfileMenu}
                />
              </div>
            )}
          </SectionCus>
        </div>

        <OurPhilosophy />

        <WhatWeDo />

        <Testimonials />

        <DuprAthletes />

        <ExploreTechnology />

        <Footer onToggleIframe={onToggleIframe} />
      </div>
      {showDropdownProfileMenu && user && (
        <DropdownProfile
          onCloseModal={toggleShowDropdownProfileMenu}
          user={user}
          onRunEvent={() => {
            setShowDropdownProfileMenu(false)
            onToggleIframe()
          }}
        />
      )}
      {isMobile ? (
        <IFrameMobileModal open={openIframe} onClose={onToggleIframe} />
      ) : (
        <IFrameModal open={openIframe} onClose={onToggleIframe} />
      )}
    </>
  )
}
